import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon, Select, Button, notification } from "antd";
import axios from "axios";
import moment from "moment";

import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import ModalExportarDoc from "./modals/ModalExportarDoc";

import { getLabel } from "../../../shared/utils/labelConfig";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const RelatoriosAtendimento = ({ match }) => {
    const [disciplinas, setDisciplinas] = useState([]);
    const [disciplinaId, setDisciplinaId] = useState(
        localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso")
    );
    const [periodos, setPeriodos] = useState([]);
    const [periodoAtual, setPeriodoAtual] = useState({
        posicao: 1,
        titulo: "",
        inicio: null,
        fim: null
    });
    const [relatorios, setRelatorios] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalExportarDocVisible, setModalExportarDocVisible] = useState(false);
    const [docs, setDocs] = useState([]);
    const [isLoadingDoc, setIsLoadingDoc] = useState(false);

    const handleSelectDisciplinas = value => {
        setDisciplinaId(value);
    };

    const carregarDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/aulas/listar-turma-disciplinas",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setDisciplinas(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar as disciplinas!");
            });
    };

    const carregarPeriodos = () => {
        axios({
            method: "get",
            url: "/api/aulas/total-periodos-conteudos",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                if (response.data.length === 0) return null;

                setPeriodos(response.data);
                setPeriodoAtual(prev => ({
                    ...prev,
                    titulo: response.data[0].titulo,
                    inicio: response.data[0].dt_inicio,
                    fim: response.data[0].dt_fim
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os periodos.");
            });
    };

    const carregarAtendimentos = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/atendimento/carregar-atendimentos",
            params: {
                id: disciplinaId == "Todos" ? localStorage.getItem("codigo_curso") : disciplinaId,
                inicio: periodoAtual.inicio,
                termino: periodoAtual.fim
            }
        })
            .then(response => {
                const relatorios = response.data.map(relatorio => {
                    return {
                        id: relatorio.id,
                        estudanteNome: relatorio.titulo,
                        dataRealizacao: relatorio.data
                    };
                });

                setRelatorios(relatorios);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os atendimentos!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const selecionarPeriodo = posicao => {
        let periodo = periodos[posicao - 1];

        setPeriodoAtual({
            posicao,
            titulo: periodo.titulo,
            inicio: periodo.dt_inicio,
            fim: periodo.dt_fim
        });
    };

    const gerarPdf = relatorioId => {
        setIsLoadingDoc(true);
        axios({
            method: "get",
            url: "/api/pdf/relatorio-atendimento",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                relatorioId
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoadingDoc(false));
    };

    const abrirModalExportarDoc = () => {
        setModalExportarDocVisible(true);
    };

    const exportarEmLote = (aluno, tipo, startDate, endDate, dataEmissao) => {
        setIsLoadingDoc(true);

        axios({
            method: "get",
            url: "/api/pdf/relatorio-atendimento-em-lote",
            params: {
                disciplinaId: aluno,
                start: moment(startDate).format("YYYY/MM/DD"),
                end: moment(endDate).format("YYYY/MM/DD"),
                dataEmissao: moment(dataEmissao).format("YYYY/MM/DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setIsLoadingDoc(false);
                setModalVisible(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                setIsLoadingDoc(false);
                setModalVisible(false);
            });
    };

    useEffect(() => {
        if (localStorage.getItem("vista") === "TURMA") carregarDisciplinas();

        carregarPeriodos();
    }, []);

    useEffect(() => {
        if (disciplinaId && periodoAtual.inicio != null) carregarAtendimentos();
    }, [disciplinaId, periodoAtual]);

    const canalId = parseInt(localStorage.getItem("entidade_id"));

    const labelRelatorio = getLabel("ensinoEspecialRelatorio", { canalId });

    const { posicao, titulo } = periodoAtual;

    return (
        <>
            <div className="container container-body">
                <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                    <h3 className="titulo-bloco">{labelRelatorio} de Atendimento</h3>
                    <div className="bloco-opcoes-esquerda">
                        <Link className="botao-icon-detalhe botao-maior" to="#" title="Visualizar" onClick={abrirModalExportarDoc}>
                            <Icon type="eye" />
                        </Link>
                        <Link
                            to={`/gerir-detalhe-turma/${match.params.turma}/${
                                localStorage.getItem("vista") === "TURMA" ? "atendimentos" : "atendimentos-aluno"
                            }`}
                            className="botao-secundario botao-secundario-redondo"
                            title="Voltar"
                            style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                        >
                            <Icon type="arrow-left" />
                        </Link>
                    </div>
                </div>
                <div className="curso-diario">
                    <div className="bloco-controlos-frequencia">
                        <div className="filters">
                            <div>
                                {localStorage.getItem("vista") === "TURMA" && (
                                    <Select
                                        className="filter"
                                        placeholder="Selecionar Aluno"
                                        name="disciplinas"
                                        allowClear={true}
                                        onChange={handleSelectDisciplinas}
                                        disabled={disciplinas.length === 0}
                                    >
                                        <Option value="Todos">Todos</Option>
                                        {disciplinas.map(disciplina => (
                                            <Option key={disciplina.id} value={disciplina.id}>
                                                {disciplina.nome}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </div>
                            {periodos.length > 0 && (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Button
                                        className="botao-periodo botao-periodo-anterior"
                                        disabled={posicao === 1}
                                        style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                        onClick={() => selecionarPeriodo(posicao - 1)}
                                    >
                                        <Icon type="left" />
                                    </Button>
                                    <span>{titulo}</span>
                                    <Button
                                        className="botao-periodo botao-periodo-proximo"
                                        disabled={
                                            posicao === periodos.length || (localStorage.getItem("vista") === "TURMA" && !disciplinaId)
                                        }
                                        style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                        onClick={() => selecionarPeriodo(posicao + 1)}
                                    >
                                        <Icon type="right" />
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="lista-relatorios-atendimentos">
                        {relatorios.length === 0 && !isLoading && <div>Nenhum {labelRelatorio.toLowerCase()} encontrado.</div>}
                        {relatorios.map(relatorio => (
                            <div key={relatorio.id} className="relatorio-atendimento-item">
                                <div className="relatorio-atendimento-item-info">
                                    <div className="item-titulo">
                                        Portifólio {relatorio.estudanteNome ? ` - ${relatorio.estudanteNome}` : ""}
                                    </div>
                                    <div className="item-sub-info">
                                        <div className="item-data">
                                            <Icon type="calendar" />
                                            {moment(relatorio.dataRealizacao).format("DD/MM/YYYY")}
                                        </div>
                                        <div className="item-estado"></div>
                                    </div>
                                </div>
                                <div className="relatorio-atendimento-item-opcoes">
                                    <Button onClick={() => gerarPdf(relatorio.id)}>
                                        <Icon type="download" />
                                        PDF
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ModalLoading visible={isLoadingDoc} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
            <ModalExportarDoc
                disciplina={disciplinaId}
                visible={modalExportarDocVisible}
                onClose={() => setModalExportarDocVisible(false)}
                onSelect={(aluno, tipo, periodo, dataEmissao) => {
                    exportarEmLote(aluno, tipo, periodo.start_date, periodo.end_date, dataEmissao);
                }}
            />
        </>
    );
};

export default RelatoriosAtendimento;
